import './App.css';
import { useNavigate } from 'react-router-dom';
import { TOTAL_TOOL_COUNT } from './toolData';

function FAQ() {
  const navigate = useNavigate();

  return (
    <div className="container">
      <h1>// FAQ</h1>
      <div className="profile-comment"># Frequently Asked Questions</div>

      <div className="faq-content">
        <div className="faq-back">
          <button onClick={() => navigate('/')} className="back-button">
            ← Back to Home
          </button>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">How does it work?</h2>
          <p className="faq-answer">
            Simply enter any Steam ID or profile URL into the search box. We'll fetch the player's profile and show you links to {TOTAL_TOOL_COUNT}+ platforms for CS2 stats, FACEIT ELO, inventory value, Steam profile history, and VAC ban checks.
          </p>
        </div>
        
        <div className="faq-item">
          <h2 className="faq-question">Is there a faster way than searching?</h2>
          <p className="faq-answer">
            Yes — take any steamcommunity.com/… profile link and swap the .com wither either .vodka or .trade. You'll be redirected straight to that player's dashboard, no searching required.
          </p>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">What can I paste into the search box?</h2>
          <p className="faq-answer">
            Any of these: a 17-digit Steam64 ID, a full profile URL (steamcommunity.com/profiles/…), or a custom/vanity URL (steamcommunity.com/id/…) — or just the vanity name on its own. Vanity names are resolved automatically.
          </p>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">Is it safe?</h2>
          <p className="faq-answer">
            Yes. There's no login and nothing to connect — everything shown comes from public Steam data. We keep snapshots of public CS2 inventories for aggregate statistics; they're never published per player and are deleted after 12 months. Details on the <a href="/privacy">privacy page</a>.
          </p>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">Where does the inventory value come from?</h2>
          <p className="faq-answer">
            Your public CS2 inventory from Steam, priced with Skinport's suggested prices, refreshed every 30 minutes. Every item type counts — skins, cases, stickers, patches. Items Skinport doesn't list are shown but left out of the total. The value is an estimate, not an offer.
          </p>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">Do you earn money from the item links?</h2>
          <p className="faq-answer">
            Yes. The CSFloat buttons are affiliate links. Buying through them costs you nothing extra and supports the site.
          </p>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">Why isn't [site X] included?</h2>
          <p className="faq-answer">
            We're always looking to add more useful platforms! Request it by opening an issue on <a href="https://github.com/OddLobster/playerProperties/issues" target="_blank" rel="noopener noreferrer">GitHub</a>.
          </p>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">Does it work with private profiles?</h2>
          <p className="faq-answer">
            Some platforms (like inventory checkers) require public profiles to function. Stats platforms may have limited data for private profiles.
          </p>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">Is this official/affiliated with Valve?</h2>
          <p className="faq-answer">
            No, this is just a community tool built by a CS player who got tired of copy-pasting Steam IDs.
          </p>
        </div>
      </div>

      <div className="footer">
        <a href="/faq" className="faq-link">FAQ</a> • <a href="/privacy" className="faq-link">Privacy</a> • <a href="/feedback" className="faq-link">Feedback</a> • Built by a CS player who got tired of copy-pasting Steam IDs • Runs on Cloudflare Workers
      </div>
    </div>
  );
}

export default FAQ;
